<template>
  <div class="wrapper">
    <v-select
      item-text="text"
      item-value="value"
      hide-details
      :items="data"
      v-model="selected"
      outlined
      return-object
      :placeholder="placeholder"
      dense
    >
      <template v-slot:item="{ item }">
        <div>{{ item.text }}</div>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { isEmpty } from 'lodash'
export default {
  name: 'SmallSelect',
  props: {
    items: Array,
    entity: String,
    placeholder: String,
    params: Object
  },
  data() {
    return {
      data: [],
      selected: {}
    }
  },
  async mounted() {
    await this.changeItems()
  },
  methods: {
    ...mapActions({
      fetchItems(dispatch) {
        return dispatch(this.entity + '/fetchItems', { _limit: -1, ...this.params })
      }
    }),
    async changeItems() {
      let res = []
      if (this.items && this.items.length) res = this.items
      else res = await this.fetchItems()
      this.data = res.map(i => {
        return {
          text: i.name,
          value: i.id
        }
      })
      this.data.unshift({ text: 'Tất cả', value: '' })
    }
  },
  watch: {
    selected: function handle(val) {
      if (!isEmpty(val)) {
        this.$emit('changeSelect', val.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field .v-input__control {
    color: inherit;
    height: 28px;
    background-color: white !important;
  }
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
  .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0 8px !important;
    height: 28px;
  }
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
    > .v-input__control
    > .v-input__slot
    fieldset {
    color: rgba(0, 0, 0, 0.38);
    height: 34px;
  }
  .v-select__slot {
    height: 28px;
  }
  .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
    margin-top: 4px;
  }
  .v-text-field--outlined.v-input--is-focused fieldset {
    height: 32px;
  }
}
.wrapper {
  max-width: 100%;
}
.v-input--selection-controls .v-input__slot {
  color: inherit !important;
}
</style>
